import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";

import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {logsList_template} from "../components/templates/logsList_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";

declare var ko: any;
declare var page: any;
declare var Waypoint: any;

export class logs extends vnModule_knockoutJS{

    protected logsList_template: logsList_template;
    protected moduleXHRHdl: XMLHttpRequestHandler;
    protected optionsBulk;


    //
    // implementation of base class [vnModule]
    protected getModuleName(): string {

        return "taskExecuterslogs";
    }

    //
    // implementation of base class [vnModule]
    buildContent(): Array<Element> {

        this.logsList_template = new logsList_template("logs", this.viewModel, this)

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Logs List");

        return [this.logsList_template.build()];
    }

    public fillPage() : void{

        this.logsList_template.activateLoading();
        this.getFormData();
    }

    protected getFormData(){

        this.logsList_template.activateLoading();

        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(this.logsList_template.getViewModelForRequest())] );
        let XHRHdl = new XMLHttpRequestHandler('/api/brand/' + this.getVnAppZone().app.params.idBrand + '/logs/', params, this);

        XHRHdl.onReadyStateFunction = this.getRequestReturnFunction( [{"code": 200, "function": this.onGetFormDataReturn}], this.errorHandler);
        XHRHdl.execute();
    }

    protected onGetFormDataReturn(req: any, obj: logs) {

        //Define and fill the Operations dropdown list.
        let operationsList = [
            { id: "", name: "All"},
            { id: "generate_article_transactions", name: "Generate Transactions from Articles - Last Month"},
            { id: "generate_daily_article_transactions", name: "Generate Transactions from Articles - Today"},
            { id: "execute_transaction_reccurentCreator", name: "Generate Transactions from Recurring Rules"},
            { id: "obtain_ga_articles_dailyStats", name: "Obtain Google Analytics Stats by Article"},
            { id: "obtain_google_searchConsole_pageStats", name: "Obtain Google Search Console Stats by Page"},
            { id: "execute_sync_latest_rebuild", name: "Sync Article Latest Sections - All"},
            { id: "execute_sync_article_directory_items", name: "Sync Articles - Pinned to Directory"},
            { id: "execute_sync_emakiArticle", name: "Sync Articles"},
            { id: "sync_all_authors", name: "Sync Authors - All"},
            { id: "execute_sync_emakiAuthor", name: "Sync Authors - Updated"},
            { id: "execute_sync_jobProfiles", name: "Sync Job Profiles"},
            { id: "execute_sync_all_listing_pages", name: "Sync Listing Pages - All"},
            { id: "execute_sync_trending_type_listing_pages", name: "Sync Listing Pages - Trending Sort"},
            { id: "execute_sync_menuSite", name: "Sync Menu"},
            { id: "execute_sync_pinnedArticle", name: "Sync Pinned Articles to Homepage"},
            { id: "execute_sync_pinnedCategory", name: "Sync Pinned Categories to Homepage"},
            { id: "execute_sync_pinnedTag", name: "Sync Pinned Tags to Listing Pages"},
            { id: "execute_sync_emakiPoll", name: "Sync Polls"},
            { id: "execute_sync_giveawayArticleProduct", name: "Sync Product Giveaways"},
            { id: "execute_sync_sitemap", name: "Sync Sitemap"},
            { id: "execute_sync_static_pages", name: "Sync Static Pages"},
            { id: "execute_sync_trendingArticle", name: "Sync Trending Sections"}
        ];

        obj.logsList_template.operationFilterDropdown.setOptions(operationsList);
        obj.logsList_template.operationFilterDropdown.setLabel("Operations");

        //Get the brand information to get the shortname to get all taskExecuters that fall under brand.
        let vnApp = obj.getVnAppZone().app;
        let brands = vnApp.loggedUser.user.brands;
        let brandsDropdown =  [];

        for (let b of brands) {

            if (!b.isDeleted) {

                let row = Object.assign([], b);

                brandsDropdown.push({id: row.shortName, name: row.name});
            }
        }

        brandsDropdown.sort((a, b) => (a.id > b.id) ? 1 : -1)

        obj.logsList_template.brandFilterDropdown.setLabel("Brands");
        obj.logsList_template.brandFilterDropdown.setOptions(brandsDropdown);

        obj.getItems();
    }

    protected filterDropdownOnChange(){

        this.resetPageNumber();
        this.getItems();
    }


    public reorderLogs(){

        this.getItems();
    }

    protected filterSimpleCancel(){

        if( this.moduleXHRHdl ){
            this.moduleXHRHdl.cancelAndReset();
        }
    }

    protected getItems(){

        //If there is already a module that exists, cancel and reset it so it doesn't try to load old requests
        if (this.moduleXHRHdl) {

            this.moduleXHRHdl.cancelAndReset();
        }

        //Activate the loading
        this.logsList_template.activateLoading();

        //Create the request to send/receive the information as needed.
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/logs/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.logsList_template.getViewModelForRequest())] );
        this.moduleXHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.moduleXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        //Assign the function to this, and create the "return function()" in onGetItemsReturn to avoid a JSON error when interrupting the last calls
        this.moduleXHRHdl.onReadyStateFunction = this.onGetItemsReturn;
        this.moduleXHRHdl.execute();
    }

    protected onGetItemsReturn(req, obj: logs){

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
            });
            obj.logsList_template.deactivateLoading();
        }
    }

    protected updateList(responseParsed: any){

        this.logsList_template.setPageNumber(responseParsed.currentPage);
        this.logsList_template.setPagination(responseParsed.totalCount);
        this.logsList_template.setResultPage(responseParsed.totalCount);
        this.logsList_template.setLogs(responseParsed.data);
        this.logsList_template.resetTrackedLogId();

        let columnMessages = document.querySelectorAll("td");

        for (let columnMessage of columnMessages) {

            if( columnMessage.innerText.indexOf("taskExecuter:") != -1 ){

                columnMessage.className = "highlight-log-taskExecuter";
            }
            if( columnMessage.innerText.indexOf("locker:") != -1  ){

                columnMessage.className = "highlight-log-locker";
            }
            if( columnMessage.innerText.indexOf("statsObtainer:") != -1  ){

                columnMessage.className = "highlight-log-statsObtainer";
            }
            if( columnMessage.innerText.indexOf("ERROR") != -1  ){

                columnMessage.className = "highlight-log-error";
            }
        }
    }

    protected processSelectedAccountLogs(account){

        localStorage.setItem("accountId", account);

        if (localStorage.getItem("accountId")) {

            this.logsList_template.getTemplateViewModel().accountId(localStorage.getItem("accountId"));
        }
        this.getItems();
    }

    // required from template [logsList_template]
    protected filterSimpleOnChange(){

        this.resetPageNumber();
        this.getItems();
    }

    // required from template [logsList_template]
    protected paginationOnPageClick(){

        this.getItems();
    }

    private resetPageNumber(){

        // go back to page 1 in the pagination
        this.logsList_template.pagination.getTemplateViewModel().pageNumber(1);
    }

    protected errorHandler(req, obj): void{

        setTimeout(function(){

            obj.getVnAppZone().showNotificationToModule(new vn_app_zone_notification(vn_app_zone_notification.TYPE_ERROR, req.message));

            obj.logsList_template.deactivateLoading();
            console.log("ERROR:" + req.message);
        }, 500);
    }

    // required from template [tasksList_template]
    protected executeAction(){

        this.executeActionOnAccounts();
    }


    protected executeActionOnAccounts(){

        this.logsList_template.activateLoading();

        let vm = this.logsList_template.getViewModelForRequest();
        vm["idBrand"] = this.getVnAppZone().app.params.idBrand;
        if(localStorage.getItem("accountId")){

            vm["filters"]["accounts_selected"] = parseInt(localStorage.getItem("accountId"));
        }

        let params: Array<Array<string>> = [];
        params.push(["action", "get_execute_action"], ["data", ko.toJSON( vm )] );

        let XHRHdl = new XMLHttpRequestHandler('/api/brand/' + this.getVnAppZone().app.params.idBrand + 'logs/', params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        XHRHdl.onReadyStateFunction = this.getRequestReturnFunction( [{"code": 200, "function": this.onExecuteActionReturn}], this.errorHandler);
        XHRHdl.execute();
    }

    protected onExecuteActionReturn(req, obj: logs){

        if (req.data[0].cronCommand !== undefined){

            setTimeout(function(){

                obj.getVnAppZone().addNotificationToModule(new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Actions applied with success."));
                obj.getVnAppZone().showNotificationToModule();

                obj.logsList_template.deactivateLoading();

                obj.refreshLogList();

            }, 500);
        }
        else {

            obj.getVnAppZone().addNotificationToModule(new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Actions applied with success."));
            obj.getVnAppZone().showNotificationToModule();
            obj.logsList_template.deactivateLoading();
        }
    }

    protected refreshLogList(){

        window.location.reload(true);
        this.processSelectedAccountLogsRefresh();
    }

    protected processSelectedAccountLogsRefresh(){

        if (localStorage.getItem("accountId")) {

            this.logsList_template.getTemplateViewModel().accountId(localStorage.getItem("accountId"));
        }

        this.getItems();
    }
}


// WEBPACK FOOTER //
// ./js/modules/logs.ts